import { render, staticRenderFns } from "./CompanyEditSubscriptionModuleMetaDataExtraDossiers.vue?vue&type=template&id=39c461ca&"
import script from "./CompanyEditSubscriptionModuleMetaDataExtraDossiers.vue?vue&type=script&lang=ts&"
export * from "./CompanyEditSubscriptionModuleMetaDataExtraDossiers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39c461ca')) {
      api.createRecord('39c461ca', component.options)
    } else {
      api.reload('39c461ca', component.options)
    }
    module.hot.accept("./CompanyEditSubscriptionModuleMetaDataExtraDossiers.vue?vue&type=template&id=39c461ca&", function () {
      api.rerender('39c461ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyEditSubscriptionModuleMetaDataExtraDossiers.vue"
export default component.exports